import { render, staticRenderFns } from "./ElasticChatStartup.vue?vue&type=template&id=301378a8&scoped=true&"
import script from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChatStartup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301378a8",
  null
  
)

export default component.exports